var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBoxContactMobile = function SvgBoxContactMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61.238l302.502.239 5.253 6.685H.74L6.61.238z",
    fill: "#F3F4F5"
  })));
};
export default SvgBoxContactMobile;